import React, { createContext, useContext, useState } from "react";

// Create the context
const FormContext = createContext();

// Create the provider component
export const FormProvider = ({ children }) => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [serviceDetails, setServiceDetails] = useState(null);

  const openForm = (service = null) => {
    setServiceDetails(service);
    setIsFormOpen(true);
  };
  
  const closeForm = () => {
    setIsFormOpen(false);
    setServiceDetails(null);
  };

  return (
    <FormContext.Provider value={{ isFormOpen, openForm, closeForm, serviceDetails }}>
      {children}
    </FormContext.Provider>
  );
};

// Custom hook to use the form context
export const useForm = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useForm must be used within a FormProvider");
  }
  return context;
};

export default FormContext;
